export default "__VITE_ASSET__BPKGaB7I__"